import ArchitectureDiagram from './ArchitectureDiagram';
export default ArchitectureDiagram;
